import React from 'react'

function TopNotch() {
   return (
      <section className="container-fluid section_primary_bg">
         <div className="container text-center mb-4 innovation_comman blockchain_innovation">
            <h1 className="tech_title section_heading_title mb-2">
               Top-Notch Features That Define Cutting-Edge Real Estate Apps
            </h1>
            <p className="sub_body">
               Being the first to develop real estate apps, we design scalable and feature-rich apps that are intended to increase user engagement and boost business growth. Our applications stand out with advanced functionalities that ensure seamless property search and management experiences.
            </p>
         </div>

         <div className="container text-center">
            <div className="innovation_card_main blockchain_innovation_card_main industry_web_new">
               <div className="row g-4 industry-grid travel-tourism-wrap">
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="../assets/svg/industries/realstate/c1.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">Smart Search Filters</h4>
                        <p className="industry-description">
                           This functionality provides refined search experience to users by
                           sorting properties on location, price range, property type, size,
                           and amenities. It makes the search experience easy, enabling users
                           to find the most appropriate properties promptly and efficiently.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="../assets/svg/industries/realstate/c2.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Interactive Property Maps
                        </h4>
                        <p className="industry-description">
                           Our app integrates dynamic property listing maps, enabling users to
                           explore nearby amenities, neighborhood details, and property
                           locations with precision. This visual representation enhances the
                           property search experience by providing geographic context.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper line-before">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="../assets/svg/industries/realstate/c3.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Property Comparison Tool
                        </h4>
                        <p className="industry-description">
                           Simplify decision-making with a side-by-side property comparison
                           feature. Users are able to compare several listings based on
                           important criteria like price, amenities, and location, and hence
                           make an informed choice.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="../assets/svg/industries/realstate/c4.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           AI-Powered Recommendations
                        </h4>
                        <p className="industry-description">
                           Take advantage of artificial intelligence power to make personalized
                           property recommendations. The app uses user behavior and preferences
                           to render individualized recommendations for an increased overall user
                           satisfaction.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="../assets/svg/industries/realstate/c5.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Mortgage & EMI Calculator
                        </h4>
                        <p className="industry-description">
                           Assist users in calculating their monthly payments using an integrated
                           mortgage calculator. It considers the property value, interest rates,
                           and down payment, giving them accurate financial information.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="../assets/svg/industries/realstate/c6.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Advanced Property Management
                        </h4>
                        <p className="industry-description">
                           Our application comes with a detailed property management system,
                           enabling landlords and agents to easily manage listings, rent
                           collection, tenant applications, and maintenance requests.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="../assets/svg/industries/realstate/c7.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           User Reviews and Ratings
                        </h4>
                        <p className="industry-description">
                           Allow users to rate properties and post comprehensive reviews. This
                           will enable potential buyers and tenants to make well-informed
                           decisions on past experience, while property owners can establish
                           trust by positive word-of-mouth.
                        </p>
                     </div>
                  </div>

                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="../assets/svg/industries/realstate/c8.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">Advanced Search Filters</h4>
                        <p className="industry-description">
                           Improve property search with layered filtering capabilities that enable
                           users to filter results by properties of size, number of bedrooms,
                           amenities, and proximity to landmarks. This helps provide more precise
                           and pertinent search results.
                        </p>
                     </div>
                  </div>
                  <div className="col-lg-4 col-md-6 industry-card-wrapper">
                     <div className="industry-card">
                        <div className="icon-circle">
                           <img
                              src="../assets/svg/industries/realstate/c9.svg"
                              alt="Fintech Icon"
                           />
                        </div>
                        <h4 className="industry-subtitle fw-semibold">
                           Property Listing Apps Integration
                        </h4>
                        <p className="industry-description">
                           Integrate your app smoothly with well-known listing sites such as
                           Zillow, Realtor.com, or Redfin. The integration helps users view more
                           properties while still maintaining their search within your app.
                        </p>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default TopNotch
